"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RelatedInputTableChangeError = void 0;
exports.changeRelatedInputTable = changeRelatedInputTable;
class RelatedInputTableChangeError extends Error {
    constructor(message) {
        super(message);
        this.name = 'RelatedInputTableChangeError';
    }
}
exports.RelatedInputTableChangeError = RelatedInputTableChangeError;
/** The editor and AI writer share binding replacement and mapping cleanup. */
function changeRelatedInputTable(tables, mappings, change) {
    if (change.operation === 'add') {
        if (tables.some(table => table.id === change.table.id ||
            table.linkedVia === change.table.linkedVia))
            throw new RelatedInputTableChangeError('This relation is already bound.');
        return {
            inputTables: [...tables, change.table],
            inputMappings: [...mappings],
        };
    }
    const previous = tables.find(table => table.id === change.id);
    if (!previous)
        throw new RelatedInputTableChangeError('Related input table not found.');
    if (change.operation === 'remove')
        return {
            inputTables: tables.filter(table => table.id !== change.id),
            inputMappings: mappings.filter(mapping => mapping.inputTableId !== previous.id &&
                mapping.inputTableId !== previous.tableId),
        };
    if (tables.some(table => table.id !== change.id && table.linkedVia === change.table.linkedVia))
        throw new RelatedInputTableChangeError('This relation is already bound.');
    return {
        inputTables: tables.map(table => table.id === change.id
            ? {
                ...table,
                ...change.table,
                filterGroup: undefined,
                multiFieldName: undefined,
            }
            : table),
        inputMappings: mappings.filter(mapping => mapping.inputTableId !== change.id),
    };
}
//# sourceMappingURL=input-table-config.js.map